import { RootState } from "../root.reducer";
import { getBanners } from "../root.selectors";

export const isRoamingLimitInfoVisible = (state: RootState): boolean =>
  getBanners(state).roamingLimitInfoVisible;

export const isAllowListOverrideVisible = (state: RootState): boolean =>
  getBanners(state).allowListOverrideVisible;

export const isBlockedLimitInfoVisible = (state: RootState): boolean =>
  getBanners(state).blockedLimitInfoVisible;

export const isProfileLimitInfoVisible =
  (profileId: string) =>
  (state): boolean =>
    getBanners(state).profileLimitInfoVisible[profileId];
